import Vue from 'vue'
import iView from 'iview'

import 'iview/dist/styles/iview.css'

Vue.use(iView);
